import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { WORK_API } from './api';
import { extractErrorMessage } from '../../utils/apiErrors';

export const useOvertimePreview = (ticket, body, editable) => {
  const [result, setResult] = useState(null), [error, setError] = useState(''), [loading, setLoading] = useState(false), [retry, setRetry] = useState(0);
  const sequence = useRef(0);
  const automatic = editable && ['draft', 'returned'].includes(ticket.status);
  useEffect(() => {
    if (!automatic) return;
    const current = ++sequence.current;
    const controller = new AbortController();
    setLoading(true); setError(''); setResult(null);
    const timer = setTimeout(async () => {
      try {
        const response = await axios.post(`${WORK_API}/tickets/${ticket.id}/time-preview`, body, { signal: controller.signal });
        if (current === sequence.current) setResult(response.data);
      } catch (e) { if (current === sequence.current && !axios.isCancel(e)) setError(extractErrorMessage(e, 'Unable to calculate overtime')); }
      finally { if (current === sequence.current) setLoading(false); }
    }, 250);
    return () => { clearTimeout(timer); controller.abort(); sequence.current += 1; };
  }, [automatic, ticket.id, ticket.revision, body, retry]);
  return { result: automatic ? result : { totals: ticket.totals, overtime: ticket.overtime }, error, loading, retry: () => setRetry((v) => v + 1) };
};